/**
 * FlyFreely API
 *
 * Contact: support@flyfreely.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface LosOperatingCategory {
    id: number;
    type: 'LOS';
    value?: LosOperatingCategory.Value;
}

export namespace LosOperatingCategory {
    export type Value = 'VLOS' | 'EVLOS' | 'BVLOS';
    export const Value = {
        VLOS: 'VLOS' as Value,
        EVLOS: 'EVLOS' as Value,
        BVLOS: 'BVLOS' as Value
    };
}
